import React, { useEffect, useContext, useState, useCallback } from "react";

import "./Workout.scss";
import Check from "./check.png";
import { getPhases } from "../../services/firebase/firestore/getData";


const phasesSet = [{
    name: "naam",
    workout: {category: "Upper", created: {nanoseconds: 638000000, seconds: 1629371636}, description: "Training program focused on strength, explosiveness, speed and conditioning for football center backs.", "id": "2021-11-15", image: "https://firebasestorage.googleapis.com/v0/b/aurum-fitness.appspot.com/o/aurum%2Fworkouts%2Fdummy-800x800-a366.jpg?alt=media&token=ef323dc5-2b6e-4424-8693-8af95ba64fd4", last_updated: {nanoseconds: 51000000, seconds: 1636228607}, name: "Free Pro Players - Center Back Workout", supersets: [{exercises: [Array], id: "7321-8681", name: "test", rest_time_in_minutes: 0}, {exercises: [Array], id: "4184-5523", name: "test2", rest_time_in_minutes: 0}]},
    mealplan: {category: "Sort by name", created: {nanoseconds: 970000000, seconds: 1621884494}, description: "description", id: "2021-11-15", image: "https://firebasestorage.googleapis.com/v0/b/aurum-fitness.appspot.com/o/aurum%2Fmealplans_delete%2F122fd5f2-53c2-524d-de33-a518e3e0e048.png?alt=media&token=c0203776-f831-467c-944b-51c94ec14846", last_updated: {nanoseconds: 515000000, seconds: 1622020491}, name: "Bulk ", plan: [{food: [Array], id: "8796-8897a", name: "breakfast"}]},
    active: true
  },
  {
    name: "test2",
    workout: {category: "Upper", created: {nanoseconds: 638000000, seconds: 1629371636}, description: "Training program focused on strength, explosiveness, speed and conditioning for football center backs.", "id": "2021-11-15", image: "https://firebasestorage.googleapis.com/v0/b/aurum-fitness.appspot.com/o/aurum%2Fworkouts%2Fdummy-800x800-a366.jpg?alt=media&token=ef323dc5-2b6e-4424-8693-8af95ba64fd4", last_updated: {nanoseconds: 51000000, seconds: 1636228607}, name: "Free Pro Players - Center Back Workout", supersets: [{exercises: [Array], id: "7321-8681", name: "test", rest_time_in_minutes: 0}, {exercises: [Array], id: "4184-5523", name: "test2", rest_time_in_minutes: 0}]},
    mealplan: {category: "Sort by name", created: {nanoseconds: 970000000, seconds: 1621884494}, description: "description", id: "2021-11-15", image: "https://firebasestorage.googleapis.com/v0/b/aurum-fitness.appspot.com/o/aurum%2Fmealplans_delete%2F122fd5f2-53c2-524d-de33-a518e3e0e048.png?alt=media&token=c0203776-f831-467c-944b-51c94ec14846", last_updated: {nanoseconds: 515000000, seconds: 1622020491}, name: "Bulk ", plan: [{food: [Array], id: "8796-8897a", name: "breakfast"}]},
    active: false
  }
];

export default function Phase({ client_id, time }) {
    const [phases, setPhases] = useState(phasesSet);
    console.log(phases);
    useEffect(() => {
        localStorage.removeItem("tabIndex")
        getPhases(client_id , (result) => {
            console.log(result)
          setPhases(result);
        });
      }, [time]);



  return (
    <div className="c-workout-wrapper">
      <div className="c-workout-content">
        {phases && phases.map((phase) => {
            return <>
                <div style={{display: "flex"}}>
                    <h1 style={{marginRight: 30}}>{phase.name}</h1>
                    {phase.active === true &&
                        <h1 style={{fontSize: 15, marginTop: 30, color: "green"}}> active</h1>
                    }
                </div>
                

                <span></span>
                <h2>Workout</h2>
                {phase?.workout && phase?.workout.supersets.map((item) => {
                return <>
                        <h3 className="c-workout-title">{item.name}</h3>  
                        <div className="c-workout-item-grid">
                            {item.exercises && item.exercises.map((item) => {
                            return <>
                                    <div key={item.id + Math.random()*5000} className="c-workout-item">
                                        <img className="c-workout-item--img" src={item?.completed? Check : ""}/>
                                        <div>
                                        <h3 className="c-workout-item--title">{item.name}</h3>
                                        <span className="c-workout-item--count">Eccentric {item.up} - Pause {item.down_pause} - Concentric {item.down} - Rest {item.rest_time_in_minutes} - Reps {item.reps} - Sets {item.sets}</span>
                                        </div>
                                    </div>
                                    <p className="c-workout-item--kg">{item.kg} kg</p>
                                    </>
                            })}
                        </div>
                        </>
                })}
                <h2>MealPlan</h2>
                {phase?.mealplan && phase?.mealplan.plan.map((item) => {
                    return <>
                        <h3 className="c-workout-title">{item.name}</h3>
                            {item.food && item.food.map((foodItem) => {
                                // if(foodItem.eaten) {
                                //     eatenCalories = parseInt(eatenCalories) +  parseInt(foodItem.calories);
                                // }
                            })}
                            
                            {/* <p className="c-mealplan-count">{eatenCalories} van {item.totalCaloriesAllowed}</p> */}
                            
                            {item.food && item.food.map((foodItem) => {
                                return <>
                                    <div key={Math.random()*5000} className="c-mealplan-item">
                                        <img className="c-mealplan-item--img" src={foodItem.completed? Check : ""}/>
                                        <div>
                                            <h3 className="c-mealplan-item--title">{foodItem.name}</h3>
                                            <span className="c-mealplan-item--count">{foodItem.quantity}g</span>
                                        </div>
                                    </div>
                                    <p className="c-mealplan-item--kcal">{parseInt(foodItem.calories)}</p>
                                </>
                            })}
                    </>
                })}
                </>
        })}
        {!phases? <p className="c-mealplan-empty">This client has no phase for this session yet.</p> : ""}  
      </div> 
    </div>
  );
}
